import React from 'react';
import LoginForm from '../LoginForm/LoginForm';
import { useHistory } from 'react-router-dom';
import './LoginPage.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

function LoginPage() {
  const history = useHistory();

  return (
    <>
    <div id='login-page'>
      <Nav />
      <LoginForm />
      {/* <center>
        <button
          type="button"
          className="btn btn_asLink"
          onClick={() => {
            history.push('/registration');
          }}
        >
          Register
        </button>
      </center> */}
    </div>
    <Footer />
    </>
  );
}

export default LoginPage;